var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-wrap" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { name: "gzzs" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("公证证书")
              ]),
              _c("safeguard-table", {
                attrs: { "current-name": _vm.activeName }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "gzbgh" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("保管函")
              ]),
              _c("baoguanhan-table", {
                attrs: { "current-name": _vm.activeName }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "ezj" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("E证据")
              ]),
              _c("eevidence-table", {
                attrs: { "current-name": _vm.activeName }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25aaf5ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25aaf5ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/order.vue
// module id = 4oEU
// module chunks = 99